import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import FormResStatus from '@/api/form-res-status';
import REQ_URL from '@/consts/req-url';
import { ClientOrManager } from '@/api/profile';
import storageObservable from '@/api/storageObservable';

@Component({
    mixins: [validationMixin],
    validations: {
        formData: {
            login: { required },
            pass: { required },
            region: { required },
        }
    },
})
export default class TheLogin extends Vue {
    showPass = false
    something: string = ''
    formStatus = new FormResStatus()
    formData = {
        pass: '',
        login: '',
        remember: false,
        region: '',
    }
    regions = [
        { label: "Нижний Новгород", value: "Нижний Новгород" },
        { label: "Иркутск", value: "Иркутск" },
        { label: "Казань", value: "Казань" },
        { label: "Красноярск", value: "Красноярск" },
        { label: "Санкт-Петербург", value: "Санкт-Петербург" },
        { label: "Самара", value: "Самара" },
        { label: "Москва", value: "Москва" },
        { label: "Воронеж", value: "Воронеж" },
        { label: "Екатеринбург", value: "Екатеринбург" },
        { label: "Ростов-на-Дону", value: "Ростов-на-Дону" },
        { label: "Хабаровск", value: "Хабаровск" },
        { label: "Новосибирск", value: "Новосибирск" },
        { label: "Пятигорск", value: "Пятигорск" },
        { label: "Краснодар", value: "Краснодар" }
    ]
    get valid() {
        return this.formData.pass && this.formData.login && this.formData.region
    }
    @Watch('formData.login') onLoginChanged(value: string, oldValue: string) {
        this.formStatus.reset()
    }
    @Watch('formData.pass') onPassChanged(value: string, oldValue: string) {
        this.formStatus.reset()
    }

    async submit() {
        this.$v.$touch();
        if (!this.$v.$error) {
            try {
                let data = await this.$fetch<ClientOrManager>(REQ_URL.LOGIN, {
                    method: 'POST',
                    body: JSON.stringify(this.formData),
                    credentials: 'same-origin'
                }, this.formStatus)

                if (data.body) {
                    this.$store.dispatch('setProfile', data.body);
                    storageObservable.emit('login', data.body);

                    (this.$refs.form as any).reset()
                    this.$v.$reset()
                    if ((data.body as ClientOrManager).type === 'client')
                        this.$router.push('/')
                    else
                        this.$router.push('/my-profile/clients')
                }
                else throw new Error('Response body are empty')
            } catch (error) {
                console.error(error.message)
            }
        }
    }
    created() {
        storageObservable.subscribe('login', (e: ClientOrManager) => {
            this.$store.dispatch('setProfile', e);
            this.$router.push('/');
        })
    }
    mounted() {
        localStorage.removeItem('currentManagerClient')
    }
}